import { render } from "./mainTable.vue?vue&type=template&id=7d2efe18&scoped=true"
import script from "./mainTable.vue?vue&type=script&lang=js"
export * from "./mainTable.vue?vue&type=script&lang=js"

import "./mainTable.vue?vue&type=style&index=0&id=7d2efe18&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2efe18"]])

export default __exports__